import { Typography } from '@mui/material';
import React from 'react';

const NotFound = () => {
  return <Typography>Not found</Typography>;
};

export default NotFound;
